import * as React from 'react';

// tslint:disable:max-line-length
export const PromotionsMortgageIcon = (props: React.HTMLAttributes<SVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
    <g fill="none" fillRule="evenodd">
      <circle cx="13" cy="13" r="13" fill="#FF9D00" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M7.216 9.623V6.447h1.8V8.05l3.188-2.784a2 2 0 0 1 2.632 0l6.584 5.752a1 1 0 0 1-.658 1.753h-.922v5.669a2 2 0 0 1-2 2H9.059a2 2 0 0 1-2-2V12.77h-.781a1 1 0 0 1-.658-1.753l1.596-1.394z"
      />
      <g fill="#FF9D00">
        <path d="M14.884 11.44l.716.556-4.484 5.684-.716-.556zM10.4 14.56a2.08 2.08 0 1 1 0-4.16 2.08 2.08 0 0 1 0 4.16zm0-1.001a1.079 1.079 0 1 0 0-2.158 1.079 1.079 0 0 0 0 2.158zM15.6 18.72a2.08 2.08 0 1 1 0-4.16 2.08 2.08 0 0 1 0 4.16zm0-1.001a1.079 1.079 0 1 0 0-2.158 1.079 1.079 0 0 0 0 2.158z" />
      </g>
    </g>
  </svg>
);
